<template>
  <div class="field">
    <span style="font-size: 30px" class="label">
      {{ label }}
      <span style="font-size: 15px">
        <arrow-up-outlined style="color: crimson" v-if="value1" />
        <arrow-down-outlined style="color: limegreen" v-if="!value1" />
      </span>
      &nbsp;&nbsp;&nbsp;
    </span>
    <span style="font-size: 25px; color: #999999" class="number">
      {{ value }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  name: 'FieldBig',
  props: {
    label: {
      type: String,
      default: () => undefined,
    },
    value: {
      type: [Number, String],
      default: () => undefined,
    },
    value1: {
      type: Boolean,
      default: () => undefined,
    },
  },
  components: {
    ArrowUpOutlined,
    ArrowDownOutlined,
  },
});
</script>

<style lang="less" scoped>
@import './index.less';
</style>
